// src/helpers/factories/settings/registerTicketFactory.ts
var MODIFIER_DISPLAY_TYPE_OPTIONS = [
  "comma" /* COMMA */,
  "vertical" /* VERTICAL */
];
var displayModeDropdownFactory = (t) => [
  {
    label: t(
      "settingsModule.registerTicketSettings.ticketDisplay.modifiersDisplay.modifierItemDisplayMode.options.comma"
    ),
    value: MODIFIER_DISPLAY_TYPE_OPTIONS.indexOf("comma" /* COMMA */) + 1
  },
  {
    label: t(
      "settingsModule.registerTicketSettings.ticketDisplay.modifiersDisplay.modifierItemDisplayMode.options.vertical"
    ),
    value: MODIFIER_DISPLAY_TYPE_OPTIONS.indexOf("vertical" /* VERTICAL */) + 1
  }
];

export { MODIFIER_DISPLAY_TYPE_OPTIONS, displayModeDropdownFactory };
